import React from 'react';
import styled, { css } from 'styled-components';
import { StrapiLayout } from '~/graphql/types';

export type Props = Omit<StrapiLayout, '__typename'> & {
  dataTestId?: string;
};

const StrapiLayout: React.FCC<Props> = ({ children, css }) => (
  <Container $css={css}>{children}</Container>
);

const Container = styled.div<{ $css?: string | null }>(
  ({ $css }) => css`
    position: relative;
    width: 100%;

    ${$css &&
    css`
      ${$css}
    `}
  `,
);

export default StrapiLayout;
